module.exports = __webpack_public_path__ + "img/flag.ccd48ffa.svg";